// extracted by mini-css-extract-plugin
export default {"shop-wrap":"XzPnohA7ryvys5A2xEO0","shop-content":"jlkcqpvhfWHkj0B5K5BO","store-list":"rzln93rDzh5Fl6Cf7e3J"};